// Centralized env reader with defaults/types
const baseConfig = {
  backendUrl: process.env.REACT_APP_BACKEND_URL,
  backendServiceApiBase: process.env.REACT_APP_BACKEND_SERVICE_API_BASE,
  debugMode: process.env.REACT_APP_DEBUG_MODE === 'true',
  localMode: process.env.REACT_APP_LOCAL_MODE === 'true',
  publicUrl: process.env.PUBLIC_URL,
  appName: process.env.REACT_APP_APP_NAME,
  turnstileSiteKey: process.env.REACT_APP_TURNSTILE_SITE_KEY || '',

  displayRegistrationForm: process.env.REACT_APP_DISPLAY_REGISTRATION_FROM !== 'false',
  displayAgenda: process.env.REACT_APP_DISPLAY_AGENDA !== 'false'
};

// Optional: Console warn on dev for missing vars
if (process.env.NODE_ENV === 'development') {
  Object.entries(baseConfig).forEach(([key, value]) => {
    if (value === undefined || value === '') {
      console.warn(`Missing env var: ${key}`);
    }
  });
}

export default baseConfig;